<template>
  <div v-if="project">
    <div class="project-name">
      {{ project.name }}
    </div>

    <div class="project-tracks-count text-stardust-grey">
      {{ project.trackcount }} Tracks.
    </div>

    <div class="form-group">
      <label for="projectNameInput"> Project Name: </label>

      <input
        type="text"
        class="form-control"
        id="projectNameInput"
        placeholder="My Project"
        v-model="project.name"
        maxlength="30"
      />
    </div>

    <div class="form-group">
      <label for="projectDescriptionInput"> Project Description: </label>

      <textarea
        class="form-control"
        id="projectDescriptionInput"
        placeholder="Project Description (optional)"
        v-model="project.description"
        cols="30"
        rows="3"
      />
    </div>

    <div class="form-group">
      <label for="projectDescriptionInput"> Project Tab Color: </label>

      <swatches-picker v-model="color" :palette="projectTabColorPalette" />
    </div>

    <a
      class="btn btn-raised btn-danger btn-xl font-weight-semibold"
      href="#"
      v-on:click.prevent="save"
    >
      Save Changes
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { Swatches } from "vue-color";

export default Vue.component("edit-project", {
  name: "EditProject",

  data() {
    return {
      project: null,
      color: false,
      projectTabColorPalette: window.projectTabColorPalette
        ? window.projectTabColorPalette
        : [],
    };
  },

  mounted() {
    // When a new project is created, also display the modal.
    playerService.$on("project-added", (project) => {
      // Update curr track for modal.
      this.project = project;
      this.reset();
    });

    // Change the edit project contents depending on whats passed to it.
    playerService.$on("edit-project", (project) => {
      // Update curr track for modal.
      this.project = project;
      this.reset();

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#editProjectModal");
    });
  },

  methods: {
    save() {
      if (this.color) {
        this.project.color = this.color.hex ? this.color.hex : this.color;
      }

      playerService.saveProject(this.project);
    },

    reset() {
      this.color = false;

      if (this.project && this.project.color) {
        const existingColor = String(this.project.color).trim();

        if (/^#[0-9A-Fa-f]{6}$/.test(existingColor)) {
          this.color = { hex: existingColor };
        }
      }
    },
  },

  watch: {
    project() {
      this.reset();
    },
  },

  components: {
    "swatches-picker": Swatches,
  },
});
</script>
